// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__38kmG","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__33rBd"};